import { useEffect, useMemo, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';

interface Props {
  defaultPageTitle: string
  open: boolean
  handleClose: () => void
  handleSave: (title: string) => void
}

const Index = (props: Props) => {
  const {
    defaultPageTitle, open, handleClose, handleSave,
  } = props;
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    if (defaultPageTitle === '') {
      return;
    }

    setPageTitle(defaultPageTitle);
  }, [defaultPageTitle]);

  const title = useMemo(() => {
    if (defaultPageTitle === '') {
      return 'New Page';
    }
    return 'Change page title';
  }, [defaultPageTitle]);

  // モーダルが閉じられた時に、タイトルをリセットします
  useEffect(() => () => {
    if (open) {
      return;
    }
    setPageTitle('');
  }, [open]);

  return (
    <>
      <ModalComponent
        title={title}
        confirmButtonText="Save"
        onConfirm={() => handleSave(pageTitle)}
        disabled={pageTitle.length === 0}
        show={open}
        closeModal={() => {
          handleClose();
        }}
        centered
        backdrop="static"
        backdropClassName="z-index-2000"
        style={{ zIndex: 2001 }}
        keyboard={false}
        animation={false}
        isLackOfInfo={pageTitle.length === 0}
      >
        <p className="fs-xs">
          {defaultPageTitle
            ? (
                <>
                  Change the page title.
                  <br />
                  The page title is displayed in search engine results.
                </>
            ) : (
              <>
                Enter a title for your new page.
                <br />
                It appears in search results and browser tabs.
              </>
            )}
        </p>
        <div className="d-flex gap-3">
          <label className="col-form-label text-sm-start fw-bold">Page Title</label>
          <div className="flex-fill">
            <input value={pageTitle} onChange={(e) => setPageTitle(e.target.value)} type="text" className="form-control" placeholder="New page title" />
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default Index;
